export const ASSESSMENT_ANSWERS_QUERY = '/assessment/answers';
export const ASSESSMENT_ANSWER_QUERY = '/assessment/answers/:id';
export const NEW_IN_SCOPE_DOMAINS_QUERY = '/quick-answer/new-in-scope-domains';
export const REASSESMENT_STATUS_QUERY = '/reassessment/status';
export const POLICY_REQUIREMENTS_QUERY = '/assessment/policy-requirements';
export const CONTROL_BOOKMARKS_QUERY = '/assessment/control-bookmarks';
export const SCOPING_ANSWERS_QUERY = '/assessment/scoping-answers';
export const CHANGE_SCOPING_ANSWER_MUTATION = '/assessment/scoping-answers/:domainID';
